var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'border-t border-b border-gray-500 py-4': _vm.bordered }},_vm._l((_vm.formatDescription),function(description,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(_vm.findUrls(description))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }